// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2pIa4","boxTitle":"Qualiphy_boxTitle__22x93","box":"Qualiphy_box__xRsVh","toggleWrap":"Qualiphy_toggleWrap__154eO"};